/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Emailconfirmed1Inputs */

const de__field_emailconfirmed1 = /** @type {(inputs: _Field_Emailconfirmed1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail bestätigt`)
};

/**

* @param {_Field_Emailconfirmed1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_emailconfirmed1 = /** @type {((inputs?: _Field_Emailconfirmed1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Emailconfirmed1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_emailconfirmed1(inputs)
});
export { _field_emailconfirmed1 as "_field_emailConfirmed" }